/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReinsuredPayloadDto
 */
export interface UpdateReinsuredPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateReinsuredPayloadDto
     */
    status?: UpdateReinsuredPayloadDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateReinsuredPayloadDto
     */
    reinsuredGroup?: UpdateReinsuredPayloadDtoReinsuredGroupEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateReinsuredPayloadDto
     */
    legalEntityName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReinsuredPayloadDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReinsuredPayloadDto
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReinsuredPayloadDto
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReinsuredPayloadDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReinsuredPayloadDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReinsuredPayloadDto
     */
    postcode?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReinsuredPayloadDto
     */
    comment?: string;
}


/**
 * @export
 */
export const UpdateReinsuredPayloadDtoStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;
export type UpdateReinsuredPayloadDtoStatusEnum = typeof UpdateReinsuredPayloadDtoStatusEnum[keyof typeof UpdateReinsuredPayloadDtoStatusEnum];

/**
 * @export
 */
export const UpdateReinsuredPayloadDtoReinsuredGroupEnum = {
    Aig: 'AIG',
    Allianz: 'Allianz',
    ArabiaInsurance: 'Arabia Insurance',
    AxaXl: 'AXA XL',
    BangkokInsurance: 'Bangkok Insurance',
    Captive: 'Captive',
    Chubb: 'Chubb',
    FalconInsurance: 'Falcon Insurance',
    Fubon: 'Fubon',
    HdiGlobal: 'HDI Global',
    Hollard: 'Hollard',
    HyundaiInsurance: 'Hyundai Insurance',
    KbInsurance: 'KB Insurance',
    MitsuiSumitomo: 'Mitsui Sumitomo',
    NewIndia: 'New India',
    OmanInsurance: 'Oman Insurance',
    Other: 'Other',
    Samsung: 'Samsung',
    Scor: 'SCOR',
    Sompo: 'SOMPO',
    Starr: 'Starr',
    TokioMarine: 'Tokio Marine',
    Vero: 'Vero',
    Zurich: 'Zurich'
} as const;
export type UpdateReinsuredPayloadDtoReinsuredGroupEnum = typeof UpdateReinsuredPayloadDtoReinsuredGroupEnum[keyof typeof UpdateReinsuredPayloadDtoReinsuredGroupEnum];


/**
 * Check if a given object implements the UpdateReinsuredPayloadDto interface.
 */
export function instanceOfUpdateReinsuredPayloadDto(value: object): value is UpdateReinsuredPayloadDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function UpdateReinsuredPayloadDtoFromJSON(json: any): UpdateReinsuredPayloadDto {
    return UpdateReinsuredPayloadDtoFromJSONTyped(json, false);
}

export function UpdateReinsuredPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReinsuredPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'reinsuredGroup': json['reinsuredGroup'] == null ? undefined : json['reinsuredGroup'],
        'legalEntityName': json['legalEntityName'] == null ? undefined : json['legalEntityName'],
        'name': json['name'],
        'address': json['address'] == null ? undefined : json['address'],
        'country': json['country'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'postcode': json['postcode'] == null ? undefined : json['postcode'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function UpdateReinsuredPayloadDtoToJSON(json: any): UpdateReinsuredPayloadDto {
    return UpdateReinsuredPayloadDtoToJSONTyped(json, false);
}

export function UpdateReinsuredPayloadDtoToJSONTyped(value?: UpdateReinsuredPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'reinsuredGroup': value['reinsuredGroup'],
        'legalEntityName': value['legalEntityName'],
        'name': value['name'],
        'address': value['address'],
        'country': value['country'],
        'city': value['city'],
        'state': value['state'],
        'postcode': value['postcode'],
        'comment': value['comment'],
    };
}

